/* eslint-disable import/prefer-default-export */
export const UPDATE_CUSTOM_FONTS = 'customFonts/UPDATE_CUSTOM_FONTS';
export const SET_LOADED_STATUS = 'customFonts/SET_LOADED_STATUS';
export const SET_INFO_LOADED_STATUS = 'customFonts/SET_INFO_LOADED_STATUS';
